import React, { Component } from 'react';
import { connect } from 'react-redux';
import MicroFrontend from './Microfrontend';
import history from '../../legacy/containers/History';
import {
  getCrpApiBaseUrl,
  getGoKardiaApiBaseUrl,
  getKardiaApiBaseUrl,
} from '../../legacy/containers/ApiUrls';

class ClinicianAdmin extends Component {
  render() {
    if (this.props.profile && this.props.profile.isFetching === false) {
      console.log(this.props.profile);
      return (
        <div>
          <div className="right_content">
            <div className="main_content">
              <MicroFrontend
                history={history}
                // history={this.props.history}
                host={process.env.REACT_APP_CLINICIAN_HOST}
                name="Clinician"
                userstate={this.props.profile}
                app="admin"
                crpapi={getCrpApiBaseUrl()}
                gokardiaapi={getGoKardiaApiBaseUrl()}
                kardiaapi={getKardiaApiBaseUrl()}
              />
            </div>
          </div>
        </div>
      );
    }
    return <div />;
  }
}
const mapStateToProps = state => {
  return {
    profile: state.app.dataSources.me,
  };
};

export default connect(mapStateToProps)(ClinicianAdmin);



// WEBPACK FOOTER //
// ./src/clinician/container/Microfrontend_component_Admin.jsx